
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.955 8.653C12.982 8.44 13 8.227 13 8c0-.227-.02-.44-.046-.653l1.406-1.1c.127-.1.16-.28.08-.427l-1.333-2.307a.333.333 0 00-.407-.146l-1.66.666a4.871 4.871 0 00-1.126-.653L9.66 1.613a.325.325 0 00-.326-.28H6.668a.325.325 0 00-.327.28L6.088 3.38c-.407.167-.78.393-1.127.653l-1.66-.666a.377.377 0 00-.12-.02.33.33 0 00-.286.166L1.56 5.82a.329.329 0 00.08.427l1.407 1.1A5.286 5.286 0 003.001 8c0 .22.02.44.047.653l-1.407 1.1c-.126.1-.16.28-.08.427l1.334 2.307a.333.333 0 00.406.146l1.66-.666c.347.266.72.486 1.127.653l.253 1.767c.02.16.16.28.327.28h2.667c.166 0 .306-.12.326-.28l.254-1.767c.407-.167.78-.393 1.127-.653l1.66.666c.04.014.08.02.12.02a.33.33 0 00.286-.166l1.333-2.307a.336.336 0 00-.08-.427l-1.406-1.1zm-1.32-1.14c.027.207.033.347.033.487s-.013.287-.033.487l-.094.753.594.467.72.56-.467.806-.847-.34-.693-.28-.6.454c-.287.213-.56.373-.833.486l-.707.287-.107.753-.133.9h-.933L7.3 11.68l-.706-.287a3.783 3.783 0 01-.82-.473l-.607-.467-.707.287-.846.34-.467-.807.72-.56.593-.466-.093-.754A5.363 5.363 0 014.335 8c0-.133.013-.287.033-.487l.093-.753-.593-.467-.72-.56.467-.806.846.34.694.28.6-.454c.286-.213.56-.373.833-.486l.707-.287.106-.753.134-.9h.926l.234 1.653.706.287c.287.12.554.273.82.473l.607.467.707-.287.847-.34.466.807-.713.566-.594.467.094.753zM8 5.333a2.666 2.666 0 100 5.334 2.666 2.666 0 100-5.334zm0 4c-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333c.734 0 1.334.6 1.334 1.333S8.735 9.333 8 9.333z","fill":"currentColor"}})])
          )
        }
      }
    